import { required, maxLength, email, requiredIf } from 'vuelidate/lib/validators';
import store from '@/store/index';
import { CREATE_SHIPMENT_PREFIX, GETTERS } from '../store/constants';
export default {
    name: {
        required,
        maxLength: maxLength(50)
    },
    street1: {
        required,
        maxLength: maxLength(50)
    },
    street2: {
        maxLength: maxLength(50)
    },
    street3: {
        maxLength: maxLength(50)
    },
    postalCode: {
        maxLength: maxLength(10)
    },
    city: {
        required,
        maxLength: maxLength(50)
    },
    countryCode: {
        required
    },
    stateCode: {
        required: requiredIf((vm) => {
            if (vm.countryCode === 'US' || vm.countryCode === 'CA') {
                return true;
            }
            return false;
        })
    },
    contactPerson: {
        name: {
            maxLength: maxLength(50)
        },
        phone: {
            maxLength: maxLength(50)
        },
        mails: {
            $each: {
                maxLength: maxLength(50),
                email: email
            }
        }
    },
    accountNumber: {
        
    },
    vatNumber: {
        
    },
    eoriNumber: {
        
    },
    dutyAccountNumber: {
        
    }
    
};
